export function differenceInCalendarDays(date?: string) {
  if (!date) {
    return;
  }

  const dateNow = Date.now();
  const futureDate = new Date(date).setUTCHours(0, 0, 0, 0);
  const diffInMilliSeconds = Math.abs(futureDate - dateNow) / 1000;
  const days = diffInMilliSeconds / 86_400;

  return Math.floor(days);
}
